import { Pipe, PipeTransform, inject } from '@angular/core';
import { CommunityUploadUrlService } from '../services/community-upload-url.service';

/**
 * Turns a stored `avatar_url` (`/api/media/upload/12/…/avatar-….png`) into the
 * URL an `<img>` can load. Delegates to CommunityUploadUrlService so avatars,
 * bodies and the editor cannot drift apart.
 */
@Pipe({ name: 'communityAvatarUrl', standalone: true })
export class CommunityAvatarUrlPipe implements PipeTransform {
  private uploadUrls = inject(CommunityUploadUrlService);

  transform(path: string | null | undefined): string {
    return this.uploadUrls.toDisplay(path);
  }
}
